// Toast Notification System
export function showToast(message, type = 'info', duration = 3000) {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    toast.className = `toast ${type}`;

    const title = type.charAt(0).toUpperCase() + type.slice(1);

    toast.innerHTML = `
    <div class="toast-title">${title}</div>
    <div class="toast-message">${message}</div>
  `;

    container.appendChild(toast);

    // Auto-remove after duration
    setTimeout(() => {
        toast.style.animation = 'slideOutRight 0.3s ease-out forwards';
        setTimeout(() => toast.remove(), 300);
    }, duration);
}

// Generate random ID
export function generateId() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

// Format number with commas
export function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Calculate XP for next level
export function getXPForLevel(level) {
    return Math.floor(100 * Math.pow(1.5, level - 1));
}

// Get level from total XP
export function getLevelFromXP(xp) {
    let level = 1;
    let requiredXP = 0;

    while (requiredXP <= xp) {
        level++;
        requiredXP += getXPForLevel(level);
    }

    return level - 1;
}

// Get XP progress for current level
export function getXPProgress(totalXP) {
    const level = getLevelFromXP(totalXP);
    let xpForCurrentLevel = 0;

    for (let i = 1; i < level; i++) {
        xpForCurrentLevel += getXPForLevel(i);
    }

    const xpInCurrentLevel = totalXP - xpForCurrentLevel;
    const xpNeededForNextLevel = getXPForLevel(level + 1);
    const progress = (xpInCurrentLevel / xpNeededForNextLevel) * 100;

    return {
        level,
        currentXP: xpInCurrentLevel,
        requiredXP: xpNeededForNextLevel,
        progress: Math.min(progress, 100)
    };
}

// Debounce function
export function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
